import { TAction } from '../actions/types/action';
import {
  SET_RAID_LOGGED_ENCOUNTER_LIST,
  SET_RAID_LOGGED_ENCOUNTER_PARAMETERS,
  TOGGLE_OPEN_LOGGED_ENCOUNTER
} from '../actions/raidLoggedEncounterActionCreator';
import { SHOW_RAID_RANKINGS_SPINNER } from '../actions/getRaidRankings';


const DEFAULT_STATE = {
  encounters: [],
  isLoading: false,
  openLoggedEncounters: {}
};

export default function raidLoggedEncounter(
  state: Partial<any> = DEFAULT_STATE,
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case SET_RAID_LOGGED_ENCOUNTER_LIST: {
      const encounters = action.payload.encounters || [];

      return {
        ...state,
        encounters
      };
    }
    case SET_RAID_LOGGED_ENCOUNTER_PARAMETERS: {
      return {
        ...state,
        ui: action.payload.params
      };
    }
    case SHOW_RAID_RANKINGS_SPINNER: {
      return {
        ...state,
        isLoading: action.payload.loading
      };
    }
    case TOGGLE_OPEN_LOGGED_ENCOUNTER: {
      return {
        ...state,
        openLoggedEncounters: {
          ...(state.openLoggedEncounters || {}),
          [action.payload]: state.openLoggedEncounters ? !state.openLoggedEncounters[action.payload] : true
        }
      };
    }
    default: {
      return state;
    }
  }
}
